export default __webpack_public_path__ + "static/media/skyvssea-undo.8b908bda.gif";